import React, { useState, useEffect } from 'react';
import axiosInstance from "../../../interceptor/axiosInstance";
import NotificationService from "../../Utils/NotificationService";

const GoDaddyGuide = () => {
  const [orgCode, setOrgCode] = useState('');
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    const fetchOrgDetails = async () => {
      const token = localStorage.getItem("authToken");
      if (!token) {
        setOrgCode("YOUR_ORG_CODE");
        return;
      }
      try {
        const response = await axiosInstance.get(`/org/org-details`);
        const data = response.data[0];
        setOrgCode(data.organisation_code);
      } catch (error) {
        console.error('Error fetching organization details:', error);
        setOrgCode("YOUR_ORG_CODE");
      }
    };
    fetchOrgDetails();
  }, []);

  const scriptCode = `
<div id="chat-bot-container"></div>
<script src="https://ezzdesk.com/shared_prompt.js?code=${orgCode}"></script>
  `.trim();

  const handleCopy = () => {
    navigator.clipboard.writeText(scriptCode).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 3000);
    }).catch((err) => {
      NotificationService.error('Failed to copy text: ' + err);
    });
  };


  return (
    <div style={{
      padding: '40px',
      maxWidth: '800px',
      margin: '0 auto',
      fontFamily: 'Arial, sans-serif',
      background: '#ffffff',
      color: '#333',
      lineHeight: '1.6'
    }}>
      <h1 style={{ fontSize: '28px', marginBottom: '20px', borderBottom: '1px solid #eee', paddingBottom: '10px' }}>
        Adding Ezzdesk Widget to GoDaddy Website
      </h1>

      <p style={{ fontSize: '16px', marginBottom: '30px', color: '#555' }}>
        Need to add your Ezzdesk chat widget to your GoDaddy website? This guide will walk you through the process for smooth integration using a custom code approach.
      </p>

      <div style={{ marginBottom: '30px' }}>
        <h3 style={{ fontSize: '20px', marginBottom: '10px' }}>1. Get Your Installation Code</h3>
        <p style={{ fontSize: '15px', color: '#666', marginBottom: '15px' }}>
          Below is your unique widget installation code. Click the "Copy" button to save it to your clipboard.
        </p>
        <div style={{ position: 'relative', marginBottom: '20px' }}>
          <pre style={{
            background: '#f4f4f4',
            padding: '20px',
            border: '1px solid #ddd',
            borderRadius: '5px',
            fontFamily: 'Courier New, monospace',
            fontSize: '14px',
            overflowX: 'auto'
          }}>
            {scriptCode}
          </pre>
          <button
            onClick={handleCopy}
            className='btn-color'
            style={{
              position: 'absolute',
              top: '15px',
              right: '15px',
              padding: '6px 16px',
              color: '#fff',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer',
              fontWeight: 'bold',
            }}
          >
            {copied ? 'Copied!' : 'Copy'}
          </button>
        </div>
      </div>

      <div style={{ marginBottom: '30px' }}>
        <h3 style={{ fontSize: '20px', marginBottom: '10px' }}>2. Log in to GoDaddy</h3>
        <p style={{ fontSize: '15px', color: '#666', marginBottom: '10px' }}>
          Log in to your GoDaddy Account, scroll down to <strong>All Products and Services → Websites + Marketing</strong> and choose the website you'd like to edit.
        </p>
        <img src="/assets/file-69Ci1OgfEj.png" alt="Select Website" style={{ maxWidth: '100%', borderRadius: '8px', border: '1px solid #ddd', margin: '15px 0' }} />
        <p style={{ fontSize: '15px', color: '#666', marginBottom: '10px' }}>
          Select <strong>Edit Website</strong>:
        </p>
        <img src="/assets/file-e9psaXgR56.png" alt="Edit Website" style={{ maxWidth: '100%', borderRadius: '8px', border: '1px solid #ddd', margin: '15px 0' }} />
      </div>

      <div style={{ marginBottom: '30px' }}>
        <h3 style={{ fontSize: '20px', marginBottom: '10px' }}>3. Add HTML Section</h3>
        <p style={{ fontSize: '15px', color: '#666', marginBottom: '10px' }}>
          Select the page and spot where you'd like to add the widget, and click on <strong>Add Section</strong>.
        </p>
        <img src="/assets/file-ID0Wtv3F54.gif" alt="Add Section" style={{ maxWidth: '100%', borderRadius: '8px', border: '1px solid #ddd', margin: '15px 0' }} />
        <p style={{ fontSize: '15px', color: '#666', marginBottom: '10px' }}>
          Following that, select <strong>Files & Web → HTML → Embed custom code on the page</strong>.
        </p>
        <img src="/assets/file-mf7xc8l1cj.png" alt="Embed Code" style={{ maxWidth: '75%', borderRadius: '8px', border: '1px solid #ddd', margin: '15px 0' }} />
      </div>

      <div style={{ marginBottom: '30px' }}>
        <h3 style={{ fontSize: '20px', marginBottom: '10px' }}>4. Paste the Installation Code</h3>
        <p style={{ fontSize: '15px', color: '#666', marginBottom: '10px' }}>
          Paste your copied widget installation code into the Custom Code field and click <strong>Done</strong>.
        </p>
        <img src="/assets/image_9f59b16.png" alt="Paste Code" style={{ maxWidth: '50%', borderRadius: '8px', border: '1px solid #ddd', margin: '15px 0' }} />
      </div>

      <div style={{ marginBottom: '30px' }}>
        <h3 style={{ fontSize: '20px', marginBottom: '10px' }}>5. Publish Your Changes</h3>
        <p style={{ fontSize: '15px', color: '#666', marginBottom: '10px' }}>
          Click <strong>Publish</strong> to apply the widget code to your live website, then click <strong>View Site</strong> to admire your work!
        </p>
        <img src="/assets/image_2d5ba6eb.png" alt="Publish" style={{ maxWidth: '100%', borderRadius: '8px', border: '1px solid #ddd', margin: '15px 0' }} />
      </div>

      <div style={{ background: '#f9f9f9', padding: '20px', borderRadius: '5px', borderLeft: '4px solid #007BFF' }}>
        <h4 style={{ margin: '0 0 10px 0', fontSize: '16px' }}>Need Help?</h4>
        <p style={{ margin: 0, fontSize: '14px', color: '#555' }}>
          If you encounter any issues while installing the widget, feel free to contact our support team.
        </p>
      </div>
    </div>
  );
};

export default GoDaddyGuide;
